import { IconCheck, IconX, IconAlertCircle } from '7-shared/assets';

export const statuses = {
  success: { icon: <IconCheck />, color: 'teal' },
  error: { icon: <IconX />, color: 'red' },
  warning: { icon: <IconAlertCircle />, color: 'yellow' },
};
